<section
  fxLayout="column"
  fxLayoutAlign="center center"
  class="page-container padding"
>
  <div>
    <h1>Authentication Confirmation</h1>
    <p>
      An email was sent to your inbox reset your password
    </p>
    <a mat-button color="primary" href="auth/login">Return to login</a>
  </div>
</section>
